import { render } from "./VueAudio.vue?vue&type=template&id=2235693c&scoped=true"
import script from "./VueAudio.vue?vue&type=script&lang=js"
export * from "./VueAudio.vue?vue&type=script&lang=js"

import "./VueAudio.vue?vue&type=style&index=0&id=2235693c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2235693c"

export default script